<template>
    <div class="ic-div input-group">
        <div class="input-group-text">
            <i class="ic-icons1 ic-icon-left1" :class="icon"></i>
        </div>
        <div v-if="filterClear" class="ic-icons ic-icon-right" @click="clearFilterText">
            <div class="ic-icon-arrow"></div>
            <i class="fas fa-times ic-btn-clear"></i>
        </div>
        <input ref="inputFieldRef" class="form-control" v-model="inputTextField" :placeholder="placeholder" @input="filterTextChange" />
    </div>
</template>


<script>
    import { ref } from "vue";

    export default {
        name: 'InputClear',
        props: {
            modelValue: null,
            placeholder: String,
            icon: {
                type: String,
                default: "fas fa-search",
            },
        },
        emits: ["update:modelValue"],
        setup(_, context) {
            const filterClear = ref(false);
            const inputFieldRef = ref(null);

            const inputTextField = ref('');

            const filterTextChange = () => {
                context.emit("update:modelValue", inputTextField.value);
                if (inputTextField.value.length > 0) filterClear.value = true;
                else filterClear.value = false;

                // context.emit("update:modelValue", event.target.value);
                // if (event.target.value.length > 0) filterClear.value = true;
                // else filterClear.value = false;
            };

            const clearFilterText = () => {
                // filterClear.value = false;
                inputTextField.value = "";
                // context.emit("update:modelValue", "");
                filterTextChange();
            };

            return {
                inputFieldRef,
                filterClear,
                clearFilterText,
                filterTextChange,
                inputTextField,
            };
        },
    };
</script>


<style lang="scss">
    .ic-div {
        // position: relative;
        // display: inline-block;

        // & input {
        //     padding: 7px 10px;
        //     padding-left: 1.8rem;
        //     // border: 1px solid var(--bs-light);
        //     border: 1px solid #ced4da;
        //     border-radius: 5px;
        //     line-height: 1.5;
        //     width: 100%;
        // }
        & .ic-icons {
            position: absolute;
            top: 50%;
            margin-top: -0.5rem;
            display: flex !important;
            flex-direction: row !important;
            color: #919191;
            z-index: 10;
        }
        // & .ic-icon-left {
        //     left: 0.5rem;
        //     // left: 0px;
        //     // margin: 0 10px;
        // }
        & .ic-icon-right {
            right: 0.5rem;
            // margin-right: 10px;
        }
        & .ic-icon-arrow {
            width: 0;
            height: 0;
            border-top: 7px solid transparent;
            border-bottom: 7px solid transparent;
            border-right: 6px solid #919191;
        }
        & .ic-btn-clear {
            background: #919191;
            /* color: #919191; */
            color: #ffffff;
            padding: 2px 4px;
            font-size: 0.6rem !important;
            font-weight: 900;
            text-align: end;
            /* border: 1px solid #919191; */
            cursor: pointer;
        }
    }
</style>

